import { put, select, takeLatest } from 'redux-saga/effects';
import { SpaceTabId } from 'api/models';
import { SpaceTabAPI } from 'api/space';
import { addSpaceTabsToSpace } from 'data/spaces';
import { getSpaceByIdSelector } from 'data/spaces/selectors';
import { logger } from 'services';
import { getSpaceTabDetailUrl } from 'utils/urls';
import { createSpaceTabSagaAction } from '../actions';
import { createFailure, createStart, createSuccess, embedStart } from '../index';
function* createSpaceTabSaga(action) {
    const { payload } = action;
    try {
        const { spaceTabId, handleSuccess, ...rest } = payload;
        const { space: { spaceId } } = rest;
        if (rest.spaceTabType) {
            yield put(createStart());
        } else {
            yield put(embedStart());
        }
        // TODO: remove 'as' and check if this saga is ever needed
        const response = yield SpaceTabAPI.createSpaceTab(rest);
        yield put(addSpaceTabsToSpace({
            spaceId,
            spaceTabs: [
                response.spaceTabId
            ].map(String)
        }));
        yield put(createSuccess(response));
        const space = yield select(getSpaceByIdSelector(response.space.spaceId));
        const redirectPath = getSpaceTabDetailUrl(SpaceTabId(space.project, spaceId, response.spaceTabId));
        if (handleSuccess) {
            handleSuccess(redirectPath, spaceId);
        }
    } catch (error) {
        logger.error('getSpaceTabDetailUrl failed', {
            error
        });
        yield put(createFailure());
    }
}
export function* watchCreateSpaceTabSaga() {
    yield takeLatest(createSpaceTabSagaAction.type, createSpaceTabSaga);
}
